import parse from "~/helpers/parse";
import {ArrayHelper} from "~/helpers/arrayHelper";
import {EnumHelper} from "~/helpers/enumHelper";

export enum ConditionalRuleBuiltInValueType {
  CreatedAt = 1,
  CreatedBy =  2,
  UpdatedAt = 3,
  RecordHolderName = 4,
  RecordHolderEmail = 5,

  // 2x values for Form built-ins
  FormSubmissionOriginalSubmittedAt = 21,
  FormSubmissionStepSubmittedOnDate = 22,
  FormSubmissionDisplaySubmissionId = 23,
  FormSubmissionProxySubmitterEmail = 24,
  FormSubmissionSubmitterFirstName = 25,
  FormSubmissionSubmitterLastName = 26,
  FormSubmissionSubmitterEmail = 27,
  FormSubmissionApplicationStatus = 28,
  FormSubmissionStepPaymentMethod = 29,
}

export const ConditionalRuleBuiltInValueTypeName = {
  [ConditionalRuleBuiltInValueType.CreatedAt]: "Record Created On",
  [ConditionalRuleBuiltInValueType.CreatedBy]: "Record Created By",
  [ConditionalRuleBuiltInValueType.UpdatedAt]: "Record Last Updated On",
  [ConditionalRuleBuiltInValueType.RecordHolderName]: "Record Holder Name",
  [ConditionalRuleBuiltInValueType.RecordHolderEmail]: "Record Holder Email",

  [ConditionalRuleBuiltInValueType.FormSubmissionOriginalSubmittedAt]: 'Initial Form Original Submitted On Date',
  [ConditionalRuleBuiltInValueType.FormSubmissionStepSubmittedOnDate]: '%s Submitted On Date',
  [ConditionalRuleBuiltInValueType.FormSubmissionDisplaySubmissionId]: 'Submission ID',
  [ConditionalRuleBuiltInValueType.FormSubmissionProxySubmitterEmail]: 'Email of admin data entry',
  [ConditionalRuleBuiltInValueType.FormSubmissionSubmitterFirstName]: "Submitter's First Name",
  [ConditionalRuleBuiltInValueType.FormSubmissionSubmitterLastName]: "Submitter's Last Name",
  [ConditionalRuleBuiltInValueType.FormSubmissionSubmitterEmail]: "Submitter's Email",
  [ConditionalRuleBuiltInValueType.FormSubmissionApplicationStatus]: 'Application status',

  // payment step builtin
  [ConditionalRuleBuiltInValueType.FormSubmissionStepPaymentMethod]: '%s Payment Method',

};

const PARSABLE_TYPES: readonly ConditionalRuleBuiltInValueType[] = Object.freeze([
  ConditionalRuleBuiltInValueType.FormSubmissionStepSubmittedOnDate,
  ConditionalRuleBuiltInValueType.FormSubmissionStepPaymentMethod,
]);

export const ObjectModelEntryConditionalRuleBuiltInValueTypes: ConditionalRuleBuiltInValueType[] = [
  ConditionalRuleBuiltInValueType.CreatedAt,
  ConditionalRuleBuiltInValueType.CreatedBy,
  ConditionalRuleBuiltInValueType.UpdatedAt,
  ConditionalRuleBuiltInValueType.RecordHolderName,
  ConditionalRuleBuiltInValueType.RecordHolderEmail,
]

export const FormSubmissionConditionalRuleBuiltInValueTypes: ConditionalRuleBuiltInValueType[] = [
  ConditionalRuleBuiltInValueType.FormSubmissionDisplaySubmissionId,
  ConditionalRuleBuiltInValueType.FormSubmissionProxySubmitterEmail,
  ConditionalRuleBuiltInValueType.FormSubmissionSubmitterFirstName,
  ConditionalRuleBuiltInValueType.FormSubmissionSubmitterLastName,
  ConditionalRuleBuiltInValueType.FormSubmissionSubmitterEmail,
  ConditionalRuleBuiltInValueType.FormSubmissionApplicationStatus,
  ConditionalRuleBuiltInValueType.FormSubmissionStepSubmittedOnDate,
  ConditionalRuleBuiltInValueType.FormSubmissionOriginalSubmittedAt,
];

export const FormSubmissionStepConditionalRulePaymentStepBuiltInValueTypes: ConditionalRuleBuiltInValueType[] = [
  ConditionalRuleBuiltInValueType.FormSubmissionStepPaymentMethod,
];

export function labelForConditionalRuleBuiltInType(type: ConditionalRuleBuiltInValueType, referenceLabel?: string): string {
  if (PARSABLE_TYPES.includes(type)) {
    return parse(ConditionalRuleBuiltInValueTypeName[type], referenceLabel);
  }

  return ConditionalRuleBuiltInValueTypeName[type];
}

export function valueForConditionalRuleBuiltInType(type: ConditionalRuleBuiltInValueType, referenceId?: string): string {
  return PARSABLE_TYPES.includes(type) ? concatConditionalRuleBuiltInValueKey(referenceId, type) : String(type);
}

const ConditionalRuleBuiltInValueReferenceIdSeparator = '_bivt';

function concatConditionalRuleBuiltInValueKey(referenceId: string, type: ConditionalRuleBuiltInValueType): string {
  return String(referenceId) + ConditionalRuleBuiltInValueReferenceIdSeparator + String(type);
}

export function typeForConditionalRuleBuiltInValue(value: string): ConditionalRuleBuiltInValueType {
  const typeString = ArrayHelper.last(value.split(ConditionalRuleBuiltInValueReferenceIdSeparator));
  return EnumHelper.parseStringValue(typeString, ConditionalRuleBuiltInValueType);
}

function referenceIdFromConditionalRuleBuiltInValueKey(valueKey: string): string {
  return valueKey.split(ConditionalRuleBuiltInValueReferenceIdSeparator)[0];
}

export function computedConditionalRuleBuiltInValueTypeName(type: ConditionalRuleBuiltInValueType, rule) {
  const baseName = ConditionalRuleBuiltInValueTypeName[type];
  const referenceId = referenceIdFromConditionalRuleBuiltInValueKey(rule.referenced_control_id);

  if (PARSABLE_TYPES.includes(type)) {
    const referenceName = rule.rootModel.conditionalRuleBuiltInValueReferenceName(type, referenceId);
    return parse(baseName, referenceName);
  }

  return baseName;
}